import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  backButtonLabel: {
    id: 'nNzP5Q',
    defaultMessage: 'Back to summary',
    description: 'Aria label for the back chevron icon in the header of a WWEX registration sub-view',
  },
});
